module.exports = __webpack_public_path__ + "static/media/tpn-community-board.4b78ba4e.png";